import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '../../../common/react/CommonStyles';
import { cssClass } from '../../../style';

const cssPrefix = 'search-space';

export namespace SearchSpaceStyles {
  export const Results = cssClass(cssPrefix, 'toolbar', {
    fontSize: TabStyles.Typography.Sizing.XXLarge,
    fontFamily: CommonStyles.Fonts.HeaderFont,
    marginTop: TabStyles.Spacing.MediumSpace,
  });

  export const ResultsDetails = cssClass(cssPrefix, 'results-details', {
    paddingTop: TabStyles.Spacing.LargeSpace,
    paddingBottom: TabStyles.Typography.Sizing.XLarge,
    fontFamily: CommonStyles.Fonts.HeaderFont,
    fontSize: 14,
    color: TabStyles.Typography.Color.PrimaryLight,
    height: 21, // Avoids vertical shifting when switching from spinner to text
    lineHeight: '21px'
  });

  export const ResultsDetailsBold = cssClass(cssPrefix, 'results-details-bold', {
    fontFamily: CommonStyles.Fonts.HeavyFont
  });
}
